import api from '@/lib/config/axios';
import { AgentMe } from './types';

/**
 * Busca os dados do agente logado
 */
export async function getAgentMe(): Promise<AgentMe> {
  const response = await api.get<AgentMe>('contacts/me');
  return response.data;
}
